import { baseQuery } from "src/store/helpers/baseQuery";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const fdroidsApi = createApi({
    reducerPath: "fdroidsApi",
    tagTypes: ["Fdroids"],
    keepUnusedDataFor: 300,
    baseQuery,
    endpoints: (builder) => ({
        createFdroid: rtkClient.createFdroid(builder),
        deleteFdroid: rtkClient.deleteFdroid(builder),
        getFdroids: rtkClient.getFdroids(builder),
    }),
});

export const { useCreateFdroidMutation, useDeleteFdroidMutation, useGetFdroidsQuery, usePrefetch } = fdroidsApi;
